<template>
<div class="widthFull container-fluid mainBackVaillant pt-1 mt-5">
  <div class="row justify-content-center ">

    <div class="col-md-4 mt-3 center">
      <h1 class="center widthFull"> Co-Browsing </h1>
    </div>

    <div class="col-4 col-md-2  center mr-md-5 pr-5 pl-5 pt-2">
      <h1 class="center widthFull"><img class="img-fluid widthFull pointer linkImage" v-on:click="page = 'ade'"  src="../../assets/images/AgenziaEntrate_logo.png" ></h1>
    </div>

    <div class="col-4 col-md-2  center pt-2 ml-md-5 pr-5 pl-5 pt-3">
      <h1 class="center widthFull"><img class="img-fluid widthFull pointer linkImage" v-on:click="page = 'poste'"  src="../../assets/images/Poste.jpg" ></h1>
    </div>

    <div class="widthFull container-fluid vaillantCont mt-4 borderRed">
      <div class="row justify-content-center  mb-5">


        <iframe v-if="page == 'ade' || page == ''" id="contestentry" src="https://telematici.agenziaentrate.gov.it/Main/login.jsp"
        allowvr="yes" width="100%"
        style="border:none;width:100%;min-height:500px;height:70vh!important;"
          scrolling="yes" title="Contest Entry">
       </iframe>

       <iframe   v-if="page == 'poste'" frameborder=0 target="_self" id="contestentry" src="https://business.poste.it/professionisti-imprese/prodotti/conto-bancoposta-affari.html"
       allowvr="yes" width="100%"
       style="border:none;width:100%;min-height:500px;height:70vh!important;"
        allowtransparency="true" scrolling="yes" title="Contest Entry">
      </iframe>
      <!-- https://idp-bpiol.poste.it/jod-idp-bpiol/cas/login.html -->

      </div>
    </div>
  </div>

</div>
</template>

<script>
import {
  mapState,
  mapGetters
} from 'vuex'
import axios from 'axios'
import {
  USER_REQUEST,
  USER_SET_DEFAULT_SHIP_DATA
} from 'actions/user'



const moment = require('moment')


export default {
  name: 'play',
  components: {

  },
  data() {
    return {
      loadingState: false,
      userToken: '',
      vw: window.innerWidth,
      practice: '',
      page: ''
    }
  },
  methods: {



  },
  watch: {


  },
  updated: function() {


  },
  created: function() {

  },
  mounted: function() {
    this.$scrollTo('#app', 700, {
      offset: -75
    })
  },
  computed: {
    ...mapGetters(['getProfile', 'isAuthenticated', 'isProfileLoaded']),
    ...mapState({
      profile: state => state.user.profile,
    })
  },


}
</script>

<style lang="scss" scoped>

.borderRed{
  border: 3px solid black;
}

.errorIcon {
    max-width: 150px;
    margin: 0 auto;
}

.linkImage{
  max-width: 150px;
}

</style>



// WEBPACK FOOTER //
// src/components/cobrowsing/index.vue